module.exports = __webpack_public_path__ + "img/woman.d842e1d9.png";